import { rankings } from '@/externals/gyym/user'
import { ActivityId } from '../Activities'

export const listActivityRankings = async () => {
  return await rankings.listActivityRankings()
}

export const getActivityFacilityRanking = async (activityId: ActivityId) => {
  return await rankings.getActivityFacilityRanking(activityId)
}

export const listCurrentUserRanking = async () => {
  return await rankings.getUserRanking()
}

// NOTE: 過去のuserランキングが必要になったら以下を利用:
// export const listUserRanking = async (targetMonth: string) => {
//   return await rankings.getUserRanking(targetMonth);
// };
